<template>
    <app-elements
        sectionHandle="release"
        :categoryGroups="categoryGroups"
        :displayTextSearch="true"
        :options="{
            limit: 12
        }"
    >
        <template #cardContent="release">
            <div class="t-content">
                <h1 class="c-card__title">{{ release.title }}</h1>
                <p v-html="excerpt(release.description, 144)" />
            </div>
        </template>
    </app-elements>
</template>

<script>
import AppElements from "layout/AppElements";

import Tag from "objects/Tag";

import { SECTION_HANDLES } from "src/constants";

import { excerpt } from "src/utils";

export default {
    name: "BlockReleasesList",
    components: {
        AppElements,
        Tag
    },
    data: () => ({
        SECTION_HANDLES,
        categoryGroups: [
            {
                group: "releaseTypes",
                label: "Catégorie",
                type: "radio"
            }
        ]
    }),
    props: {
        data: false
    },
    methods: {
        excerpt
    }
};
</script>

<style lang="scss">
.b-releases-list {
}
</style>
